import { mdiClipboardPulseOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { ReactNode } from "react";
import { Container, Navbar } from "react-bootstrap";

type LayoutSingleProps = {
	header?: string;
	children: ReactNode;
};

export default function LayoutSingle({ header, children }: LayoutSingleProps) {
	return (
		<>
			<Navbar variant="dark" bg="dark" className="bg-dark">
				<Container>
					<Navbar.Brand>
						<div className="d-inline-flex justify-content-start align-items-center gap-2">
							<Icon path={mdiClipboardPulseOutline} style={{ height: 40 }} />
							<div className="d-flex flex-column align-items-center fs-3 lh-">Monitor</div>
						</div>
					</Navbar.Brand>
					<Navbar.Brand className="ms-auto text-white">{header}</Navbar.Brand>
				</Container>
			</Navbar>
			<Container className="layout">{children}</Container>
		</>
	);
}
